import script from "./ApiDocsEndpointSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiDocsEndpointSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__